module.exports = __webpack_public_path__ + "static/media/activity.322faa2c.svg";